export default "__VITE_ASSET__b0918293__"